<template>
  <div class="mymap" :style="{'height':height + 'px'}">
    <g-map-map ref="mapRef" :center="center" :zoom="zoom" :map-type-id="mapType" class="chartmap"
              @zoom_changed="zoomChange" @center_changed="centerChange" :options="{fullscreenControl:false, streetViewControl: false}">

      <g-map-polygon @mouseover="mouseover($event, area)" @mouseout="mouseout($event, area)" :key="i" v-for="(area, i) in polygons"
                    :paths="area.paths" :options="area.options"/>

      <g-map-polygon ref="editPoly" v-for="(overlay,i) in overlayBorders" :paths="overlay" :editable="edit" @paths_changed="updatePath(i, $event)" v-if="overlayBorders.length>0"
                     :options="{ strokeColor: '#00aac3', strokeWeight: 3, fillColor: '#00aac3', fillOpacity: 0, zIndex: -1  }" :key="'k' + i"/>

    </g-map-map>

    <template v-if="!edit">
      <search-menu :map="map" v-if="showSearchbox" placeholder="Karte durchsuchen ..."/>

      <control-overlay :legendEnabled="showLegend" :kmlEnabled="showKML" :legendEntries="legendEntries" :map="map"
                       :kmlFileDir="kmlFileDir" :kmlTitle="kmlTitle" @show-kml-error="errorMessage = $event" :embedded="embedded"/>

      <side-query-overlay :queryID="queryID" :queryParams="queryParams" :embedded="embedded"/>

      <webentity-overlay v-if="contentEntityName" :webentityName="contentEntityName"/>
    </template>
    <template v-else>
      <textarea style="width:165px;height:70px;position:absolute;top:60px;left:10px;background:white;font-size:10px">{{ overlayBordersDisplay }}</textarea>
    </template>
    <error-message-overlay :errorMessage="errorMessage"/>
  </div>
</template>

<script>
import createTextOverlay from './TextOverlay.js'
import controlOverlay from '../../charts/ControlOverlay'
import searchMenu from '../../charts/SearchMenu'
import sideQueryOverlay from '../../charts/SideQueryOverlay'
import errorMessageOverlay from '../../charts/ErrorMessageOverlay'
import webentityOverlay from '../../charts/WebentityOverlay'
import CSVHelper from '../../../classes/CSVHelper'
import { useQueryStore } from 'src/stores/QueryStore.js'

export default {
  name: 'GoogleMapsRegion',
  props: ['height', 'chartType', 'queryColumns', 'queryResult', 'setupToken', 'queryID', 'queryParams', 'queryMeta', 'embedded'],
  components: {controlOverlay, searchMenu, sideQueryOverlay, errorMessageOverlay, webentityOverlay},

  data() {
    return {
      center: {lat: 48.30639, lng: 14.28611},
      zoom: 9,
      map: null,
      polygons: [],
      textCreator: null,
      legendEntries: [],
      showLegend: false,
      showKML: false,
      kmlFileDir: null,
      kmlTitle: null,
      showSearchbox: false,
      zoomSetByStorage: false,
      centerSetByStorage: false,
      mapType: "roadmap",
      overlay: null,
      errorMessage: null,
      edit: this.$route.query.edit !== undefined ? true : false,
      overlayBorders: [],
      overlayBordersCache: [],
      overlayBordersDisplay: "",
      contentEntityName: null
    }
  },

  watch: {
    queryResult() {
      this.polygons = []
      this.legendEntries = []
      this.init()
    }
  },

  methods: {

    init(createText) {
      this.errorMessage = null
      if (this.queryResult.length == 0) {
        this.errorMessage = this.queryMeta.msgOnEmptyresult
      } else {
        const queryStore = useQueryStore()
        try {
          queryStore.webEntityGet({ webEntityName: 'region_borders'})
            .then((webEntity) => {
              this.readOverlay()
              let districtBordersJson = safeParseJSON(webEntity.content)
              let districtBorders = districtBordersJson[0].features;
              var districtBordersLatLng = districtBorders.map((u, i) => {
                return {
                  name: u.properties.Name,
                  paths: u.geometry.coordinates.map(element => {
                    return {
                      lat: element[1], lng: element[0]
                    }
                  })
                }
              })

              let tempLegends = []
              for (let idx = 0; idx < this.queryResult.length; idx++) {
                let polygon = districtBordersLatLng.find(x => x.name.toLowerCase() == this.queryResult[idx].geo_region_name.toLowerCase())
                if (polygon) {
                  tempLegends.push({
                    legendColor: "background-color: " + this.queryResult[idx].geo_region_cardcode,
                    legendText: this.queryResult[idx].geo_region_cardcodelegend
                  })
                  polygon.options = {
                    strokeColor: 'black',
                    strokeWeight: 2,
                    fillColor: this.queryResult[idx].geo_region_cardcode,
                    fillOpacity: 0.5
                  }
                  polygon.title = this.queryResult[idx].geo_region_title
                  polygon.infowindow = new google.maps.InfoWindow({
                    content: this.queryResult[idx].geo_region_info.replaceAll("&gt;",">").replaceAll("&lt;","<")
                  });
                  this.polygons.push(polygon)
                }
              }

              this.legendEntries = this.removeDuplicates(tempLegends, "legendText")

              if (createText) {
                for (let i = 0; i < this.polygons.length; i++) {
                  let polygonBounds = new google.maps.LatLngBounds()
                  this.polygons[i].paths.forEach(element => {
                    polygonBounds.extend(element)
                  });
                  let polygonCenter = polygonBounds.getCenter();
                  let txt = new this.textCreator(polygonCenter, "<div>" + this.polygons[i].title + "</div>", "customBox", this.map)
                }
              }
            })
            .catch(error => {
              this.eventBus.globalErrorHandling("Fehler beim Erstellen der Karte", error)
              this.errorMessage = this.queryMeta.msgOnError
            })
        } catch (err) {
          this.eventBus.globalErrorHandling("Fehler beim Erstellen der Karte", err)
          this.errorMessage = this.queryMeta.msgOnError
        }
      }
    },

    updatePath(idx, mvcArray) {
      //console.log("mvcArray:", idx, mvcArray)
      let result = []
      for (let i = 0; i < mvcArray.getLength(); i++) {
        for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
          result.push({"lat": mvcArray.getAt(i).getAt(j).lat(), "lng": mvcArray.getAt(i).getAt(j).lng()})
        }
      }
      this.overlayBordersCache[idx] = result
      this.overlayBordersDisplay = JSON.stringify(this.overlayBordersCache).trim()
      //console.log("overlayBordersCache", this.overlayBordersCache)
    },

    readOverlay() {
      if (this.overlayWebentity) {
        const queryStore = useQueryStore()
        queryStore.webEntityGet({ webEntityName: this.overlayWebentity})
          .then((webEntity) => {
            if (webEntity.content) {
              this.overlayBorders = safeParseJSON(webEntity.content)
              this.overlayBordersCache = this.overlayBorders
              this.overlayBordersDisplay = JSON.stringify(this.overlayBorders).trim()
            }
          })
      }
    },

    setupConfig() {
      let mySetupToken = CSVHelper.getObjectArrayFromCSV(this.setupToken)
      //console.warn("setuptoken:", this.setupToken, "parsed:", mySetupToken)

      if (mySetupToken.mapType) {
        this.mapType = mySetupToken.mapType
      }
      this.showLegend = mySetupToken.legendActive
      this.showKML = mySetupToken.layerSidebarActive
      this.kmlFileDir = mySetupToken.layerFiledir
      this.kmlTitle = mySetupToken.layerSidebarTitle
      this.showSearchbox = mySetupToken.searchboxActive
      this.overlayWebentity = mySetupToken.overlayWebentity
      this.contentEntityName = mySetupToken.contentEntity
      if (!this.zoomSetByStorage) {
        this.zoom = mySetupToken.zoomLevel
      }
      if (!this.centerSetByStorage) {
        if (mySetupToken.latLng) {
          let splitStr = mySetupToken.latLng.split(",")
          if (splitStr.length == 2) {
            this.center = {lat: parseFloat(splitStr[0]), lng: parseFloat(splitStr[1])}
          }
        }
      }
    },

    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },

    mouseover(event, polygon) {
      if (this.map && polygon.infowindow) {
        polygon.infowindow.close()
        polygon.infowindow.setPosition(event.latLng);
        polygon.infowindow.open({map: this.map, shouldFocus: false})
      }
    },

    mouseout(event, polygon) {
      if (this.map && polygon.infowindow) {
        polygon.infowindow.close()
      }
    },

    zoomChange(zoom) {
      localStorage.setItem(this.queryID + "__zoomRegionBorder", JSON.stringify(zoom));
    },

    centerChange(center) {
      localStorage.setItem(this.queryID + "__centerRegionBorder", JSON.stringify(center));
    }
  },

  async mounted() {
    let lsCenter = localStorage.getItem(this.queryID + "__centerRegionBorder");
    let lsZoom = localStorage.getItem(this.queryID + "__zoomRegionBorder");
    if (lsCenter) {
      this.center = safeParseJSON(lsCenter)
      this.centerSetByStorage = true
    }
    if (lsZoom) {
      this.zoom = safeParseJSON(lsZoom)
      this.zoomSetByStorage = true
    }
    await this.$gmapApiPromiseLazy();
    this.textCreator = createTextOverlay(google)
    this.setupConfig()

    console.warn("edit:", this.edit)
    console.warn("overlayWebentity:", this.overlayWebentity)

    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map
      this.init(true)
    })
  }
}

</script>

<style lang="sass">
.chartmap
  height: 100%

.customBox
  background: white
  border: 1px solid black
  position: absolute
  z-index: -300
</style>
